module.exports = __webpack_public_path__ + "1cc09075c6463fa35364952ed443557a.svg";